import React from 'react';
import { ArrowRight } from 'lucide-react';

// Floating animation CSS
const floatingStyle = {
  animation: 'float 3s ease-in-out infinite',
  width: '380px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const keyframes = `
@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-30px); }
  100% { transform: translateY(0px); }
}`;

const HeroSection = () => {
  return (
    <div className="bg-white relative overflow-hidden">
      <style>{keyframes}</style>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-8 relative z-10">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                Your Journey to Better Mental Health Starts Here
              </h1>
              <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
                At Transitions Behavioral Health, we provide compassionate,
                evidence-based mental health services tailored to your unique
                needs. Our experienced team is here to support you every step of
                the way.
              </p>
            </div>
            <div className="space-y-4 md:space-y-0 md:space-x-4 flex flex-col md:flex-row">
              <button
                onClick={() => (window.location.href = "/book")}
                className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 
                          text-base font-medium rounded-md text-white bg-purple-700 hover:bg-purple-800
                          transition-colors duration-200 shadow-sm"
              >
                Book with Charm
                <ArrowRight className="w-5 h-5 ml-2" />
              </button>
            </div>
          </div>
          {/* Right Column - Animated Plane Image */}
          <div className="relative hidden md:block h-96 flex items-center justify-center">
            <img
              src={process.env.PUBLIC_URL + '/assets/plane.png'}
              alt="Animated Plane"
              style={floatingStyle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;